import React, { useState, useEffect } from 'react';
import { useMapStore } from '../store/mapStore';

const acctype = [
  { label: 'CMU', value: 'cmu' },
  { label: 'LCC', value: 'lcc' },
  { label: 'OTH', value: 'oth' },
  { label: 'TRS', value: 'trs' },
];

const industry = [
  { label: 'Restaurants & Bars', value: 'Restaurants & Bars', icon: 'assets/industries/Restaurants.svg' },
  { label: 'Healthcare', value: 'healthcare', icon: 'assets/industries/Healthcare.svg' },
  { label: 'Retail', value: 'RETAIL OUTLETS-NON-GROCERY', icon: 'assets/industries/Retail.svg' },
  { label: 'Travel & Leisure', value: 'Travel & Leisure', icon: 'assets/industries/Travel.svg' },
  { label: 'Education', value: 'education', icon: 'assets/industries/Education.svg' },
  { label: 'Government', value: 'GOVERNMENT EMPLOYMENT', icon: 'assets/industries/Government.svg' },
  { label: 'Other', value: 'All Other Foodservice', icon: 'assets/industries/Other.svg' },
];

const cuisine = ['African', 'American', 'Americanized Chinese', 'Authentic Chinese', 'Bakery', 'Bar', 'BBQ', 'Beverages', 'Brewery', 'Burgers', 'Cafe', 'Cajun/Creole', 'Caribbean', 'Chicken Wings', 'Desserts', 'Diner', 'European', 'French', 'German', 'Hawaiian', 'Hot Dogs', 'Indian', 'Irish', 'Italian', 'Japanese', 'Korean', 'Med or Mid', 'Mexican', 'Other', 'Other Asian', 'Pizza', 'Salad', 'Sandwich', 'Seafood', 'Snacks', 'South American', 'Southern/Soulfood', 'Steak', 'Sushi', 'Tacos', 'Thai', 'Vietnamese'];

const businessUnits = [
  'US Broadline', 'Freshpoint', 'SSMG', 'Hawaii',
  'Asian Foods', 'European Imports', 'Guest Supply', 'Canada'
];

const csScores = ['New', '1', '2', '3', '4', '5'];


const getDefaultFilters = () => ({
  acctype: acctype.filter(a => a.value !== 'cmu').map(a => a.value),
  industry: industry.map(i => i.value),
  cuisine: [...cuisine],
  businessUnit: [...businessUnits],
  perks: ['Enrolled', 'notEnrolled'],
  yourWay: ['Enrolled', 'notEnrolled'],
  csScore: [...csScores],
});

// wipe every value in a single section


const Filters = ({ onClose, onFiltersApplied }) => {
  const {
    filtersState,
    setFiltersState,
    searchByLatLng,
    searchCenter,
    GlobalMapCenter,
    showNeighborhoods,
    setShowNeighborhoods,
    showLeads, 
    setShowLeads,
    saveCurrentAsDefault
  } = useMapStore();

  const [pendingFilters, setPendingFilters] = useState(filtersState);
  const [validationMsg, setValidationMsg] = useState('');
  const applyCallback = onFiltersApplied || (() => { });
  const [showConfirm, setShowConfirm] = useState(false);
  const proceedClose = () => { setShowConfirm(false); onClose(); };
  const isMobile = window.innerWidth <= 800;
  const removeAll = (key) => {
    setPendingFilters((prev) => ({ ...prev, [key]: [] }));
  };
  // Filters.jsx  (inside the component function)
 
const [saveAsDefault, setSaveAsDefault] = useState(false);
const dirty = JSON.stringify(
  Object.fromEntries(
    Object.entries(pendingFilters).map(([k, v]) => [
      k,
      Array.isArray(v) ? [...v].sort() : v   // ← sort arrays
    ])
  )
) !== JSON.stringify(
  Object.fromEntries(
    Object.entries(filtersState).map(([k, v]) => [
      k,
      Array.isArray(v) ? [...v].sort() : v
    ])
  )
);


  // use this if you have a close icon / overlay
  const handleClose = () => {
    console.log("close filters clicked");
    // const dirty =
    //   JSON.stringify(pendingFilters) !== JSON.stringify(filtersState);
    
    console.log("close filters clicked without saving:", dirty);

    if (dirty) {
      setShowConfirm(true);      // open modal instead of window.confirm
    } else {
      onClose();
    }
  };

  useEffect(() => {
    setPendingFilters(filtersState);
  }, [filtersState]);

  const toggle = (key, value) => {
    const current = pendingFilters[key];
    const updated = current.includes(value)
      ? current.filter(item => item !== value)
      : [...current, value];
    setPendingFilters(prev => ({ ...prev, [key]: updated }));
  };

  const isSelected = (key, value) => pendingFilters[key].includes(value);

  const handleApply = () => {
    const empty = Object.entries(pendingFilters).find(([, v]) => v.length === 0);
    if (empty) {
      setValidationMsg('Please select at least one option in every section.');
      return;
    }
    setValidationMsg('');
    setFiltersState(pendingFilters);
    console.log('set filter state:', pendingFilters);
    console.log('search center filter apply:', GlobalMapCenter);//searchCenter);
    if (GlobalMapCenter) searchByLatLng(GlobalMapCenter.lat, GlobalMapCenter.lng);
    // if (searchCenter) searchByLatLng(searchCenter.lat, searchCenter.lng);
    if (saveAsDefault) {
      saveCurrentAsDefault(pendingFilters);
      setSaveAsDefault(false);          // reset the box
    }
     
    applyCallback();          // <‑‑ forces map remount
    onClose();                // hide panel
  };

  const handleClear = () => {
    const cleared = getDefaultFilters();
    setPendingFilters(cleared);
    setFiltersState(cleared);
    console.log('search center filter apply:', GlobalMapCenter);//searchCenter);
    if (GlobalMapCenter) searchByLatLng(GlobalMapCenter.lat, GlobalMapCenter.lng);
    // if (searchCenter) searchByLatLng(searchCenter.lat, searchCenter.lng);
    applyCallback();          // <‑‑ forces map remount
  };


  //   const handleClear = () => {
  //     const cleared = getDefaultFilters();
  //     setPendingFilters(cleared);
  //     setFiltersState(cleared);

  // if (searchCenter) searchByLatLng(searchCenter.lat, searchCenter.lng);
  //   };

  return (
    <div className="flex flex-col max-h-[calc(100vh-64px)]">
      <div className="p-4 flex justify-between items-center border-b">
        <h2 className="text-fluid-lg font-bold">Filters</h2>
        <button onClick={handleClose} className="btn-action-red">
          Close
        </button>
      </div>
      <div className="flex-1 overflow-y-auto pb-32">
        {/* Lead toggle */}
        <section className="p-4 border-b">
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                className="h-5 w-5 accent-blue-600"
                checked={showLeads}
                onChange={(e) => {
                  console.log('[ui] Show Leads clicked ->', e.target.checked);
                  setShowLeads(e.target.checked); // recompute happens in store
                }}
              />
              <span className="font-semibold">Show Leads</span>
            </label>
          </div>
        </section>
        {/* Account Type */}
        <section className="p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-fluid-base font-semibold">Account Type</h3>
            <button
              onClick={() => removeAll('acctype')}
              className="btn-action-neutral"
            >
              Remove All
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {acctype.map((type) => (
              <button
                key={type.value}
                onClick={() => toggle('acctype', type.value)}
                className={`btn-pill-fluid ${isSelected('acctype', type.value) ? 'pill-blue-sel' : 'pill-blue-unsel'}`}
                >
                {type.label}
              </button>
            ))}
          </div>
        </section>

        {/* Industry */}
        <section className="p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-fluid-base font-semibold">Industry</h3>
            <button
              onClick={() => removeAll('industry')}
              className="btn-action-neutral"
            >
              Remove All
            </button>
          </div>
          <div className="grid grid-cols-3 gap-3">
            {industry.map((item) => (
              <button
                key={item.value}
                onClick={() => toggle('industry', item.value)}
                className={`flex flex-col items-center p-3 rounded-xl border ${isSelected('industry', item.value)
                  ? 'bg-green-100'
                  : 'bg-gray-100'}`}
              >
                <img src={item.icon} alt={item.label} className="w-11 h-11 pt-3" />
                <span className="text-fluid-sm text-center mt-2">{item.label}</span>
              </button>
            ))}
          </div>
        </section>
        {/* Business Unit */}
        <section className="p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-fluid-base font-semibold">Business Unit</h3>
            <button
              onClick={() => removeAll('businessUnit')}
              className="btn-action-neutral"
            >
              Remove All
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {businessUnits.map((unit) => (
              <button
                key={unit}
                onClick={() => toggle('businessUnit', unit)}
                className={`btn-pill-fluid ${isSelected('businessUnit', unit) ? 'pill-blue-sel' : 'pill-blue-unsel'}`}              >
                {unit}
              </button>
            ))}
          </div>
        </section>
        {/* Customer Segmentation Score */}
        <section className="p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-fluid-base font-semibold">Customer Segmentation Score</h3>
            <button
              onClick={() => removeAll('csScore')}
              className="btn-action-neutral"
            >
              Remove All
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {csScores.map((score) => (
              <button
                key={score}
                onClick={() => toggle('csScore', score)}
                className={`btn-pill-fluid ${isSelected('csScore', score) ? 'pill-blue-sel' : 'pill-blue-unsel'}`}
              >
                {score}
              </button>
            ))}
          </div>
        </section>
        {/* Programs */}
        <section className="p-4">
          <h3 className="text-fluid-base font-semibold mb-2">Programs</h3>
          <div className="flex flex-col gap-4">
            <div className="flex gap-2 items-center">
              <span className="text-gray-700">Sysco Perks:</span>
              {['Enrolled', 'notEnrolled'].map((val) => (
                <button
                  key={val}
                  onClick={() => toggle('perks', val)}
                  className={`btn-pill-fluid ${isSelected('perks', val) ? 'pill-green-sel' : 'pill-green-unsel'}`}
                >
                  {val.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                </button>
              ))}
            </div>
            <div className="flex gap-2 items-center">
              <span className="text-gray-700">Sysco Your Way:</span>
              {['Enrolled', 'notEnrolled'].map((val) => (
                <button
                  key={val}
                  onClick={() => toggle('yourWay', val)}
                  className={`btn-pill-fluid ${isSelected('yourWay', val) ? 'pill-green-sel' : 'pill-green-unsel'}`}
                >
                  {val.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                </button>
              ))}
            </div>
          </div>
        </section>
        {/* Cuisine */}
        <section className="p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-fluid-base font-semibold">Primary Menu Type</h3>
            <button
              onClick={() => removeAll('cuisine')}
              className="btn-action-neutral"
            >
              Remove All
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {cuisine.map((item) => (
              <button
                key={item}
                onClick={() => toggle('cuisine', item)}
                className={`btn-pill-md ${isSelected('cuisine', item) ? 'pill-blue-sel' : 'pill-blue-unsel'}`}              >
                {item}
              </button>
            ))}
          </div>
        </section>

        {/*SYW neighborhood */}

        <section className="p-4 border-t">
        <h3 className="text-fluid-base font-semibold mb-3">Map Layers</h3>
        <label className="flex items-center gap-3">
          <input
            type="checkbox"
            className="h-5 w-5 accent-blue-600"
            checked={showNeighborhoods}
            onChange={e => setShowNeighborhoods(e.target.checked)}
          />
          <span>Show SYW Neighborhood Polygons</span>
        </label>
      </section>

      
      </div>

 
      {/* --- Action Buttons ----------------------------------- */}
      {isMobile ? (
        /* Mobile: keep the fixed bar */
        <div className="fixed bottom-0 left-0 right-0 bg-white p-4 border-t
                        border-gray-200 z-10">
          {validationMsg && (
            <div className="px-4 py-2 mb-3 text-fluid-sm text-red-600 bg-red-50
                            border-t border-red-200">
              {validationMsg}
            </div>
          )}
           {/* checkbox row – visible only when filters differ from defaults */}
            {dirty && (
              <div className="flex items-center mb-3">
                <input
                  id="saveDefault"
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-blue-600"
                  checked={saveAsDefault}
            onChange={e => setSaveAsDefault(e.target.checked)}
                />
                <label htmlFor="saveDefault" className="ml-2 text-fluid-sm">
                  Save as my default filters
                </label>
              </div>
            )}
          <div className="flex justify-between">
            <button onClick={handleClear} className="btn-secondary">
              Clear Filters
            </button>
            <button onClick={handleApply} className="btn-primary">
              Apply Filters
            </button>
           
          </div>
        </div>
      ) : (
        /* Desktop: place inside panel */
        <div className="mt-6 border-t pt-4 pr-2 pl-2">
          {validationMsg && (
            <div className="px-4 py-2 mb-3 text-fluid-sm text-red-600 bg-red-50
                            border border-red-200 rounded">
              {validationMsg}
            </div>
          )}
          {/* checkbox row – visible only when filters differ from defaults */}
            {dirty && (
              <div className="flex items-center mb-3">
                <input
                  id="saveDefault"
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-blue-600"
                  checked={saveAsDefault}
            onChange={e => setSaveAsDefault(e.target.checked)}
                />
                <label htmlFor="saveDefault" className="ml-2 text-fluid-sm">
                  Save as my default filters
                </label>
              </div>
            )}
            <div className="flex justify-between">
            <button onClick={handleClear} className="btn-secondary">
              Clear Filters
            </button>
            <button onClick={handleApply} className="btn-primary">
              Apply Filters
            </button>
          </div>

        </div>
      )}

      {showConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
          <div className="bg-white rounded-lg shadow-lg p-6 w-64 text-center">
            <p className="mb-4 text-fluid-sm">You have unsaved filter changes. Discard?</p>
            <div className="flex justify-center gap-4">
              <button
                className="px-3 py-1 border rounded-md text-gray-700"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="px-3 py-1 bg-blue-600 text-white rounded-md"
                onClick={proceedClose}
              >
                Discard
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default Filters;